import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { getDashboardModalExtensionPath } from '@wix/cli-astro-definitions';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const DASHBOARD_MODAL_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/dashboard-modal'
);

export async function generateDashboardModal(
  projectFolder: string,
  route: string,
  title: string
) {
  const cwd = getDashboardModalExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'tsx',
    });

  const config = {
    id: randomUUID(),
    title,
    width: 550,
    height: 600,
    component: relativePathToCodeFile,
  };
  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  const genResult = await componentGenerator({
    template: DASHBOARD_MODAL_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions'
        : '@wix/astro/builders',
      modalId: config.id,
      route,
      config,
    },
  });

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCase(route),
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  return genResult;
}
